import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";

import { ReviewFooter } from "../../Footer/Footer";
import { getImageUrl } from "../../utils/images";
import { showMessage, showSpinner } from "../../utils/alerts";
import { userActions } from "../../store/userState";
import Swal from "sweetalert2";
import { verifyResetOtp, resetPassword } from "../../service/authServie";
import { showMessageCustom } from "../../utils/alertwithcustomfunc";

export const ForgotPasswordEnterCode = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { email } = state;

  const dispatch = useDispatch();
  const navigator = useNavigate();

  const [newPassword, setNewPassword] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [confirmError, setConfirmError] = useState("");
  const [showoldpassword, setShowoldpassword] = useState(false);
  const [shownewpassword, setShownewpassword] = useState(false);
  const [showconfirmpassword, setShowconfirmpassword] = useState(false);

  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [input3, setInput3] = useState("");
  const [input4, setInput4] = useState("");
  const [input5, setInput5] = useState("");
  const [input6, setInput6] = useState("");
  const [input7, setInput7] = useState("");
  const [isVerifyDisable, setIsVerifyDisable] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isValidOTP, setIsValidOTP] = useState(false);
  const [isCheckingOtp, setIsCheckingOtp] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const TimerStatic = useRef(true);

  const [otpTimer, setOTPTimer] = useState(30);

  const [policies, setPolicies] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    digit: false,
    special: false,
  });

  useEffect(() => {
  const updatedPolicies = checkPasswordValid(newPassword);
  setPolicies(updatedPolicies);
  setPasswordError(
    Object.values(updatedPolicies).every(Boolean)
      ? ""
      : "Your password must meet the following criteria:"
  );
}, [newPassword]);



  const verifyOTP = (otpValue) => {};

  const checkPasswordValid = (password) => {
  return {
    length: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    digit: /[0-9]/.test(password),
    special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
  };
};

const validatePassword = (password) => {
  const updatedPolicies = checkPasswordValid(password);
  setPolicies(updatedPolicies);
  return Object.values(updatedPolicies).every(Boolean);
};

// let isFormValid ;


//   useEffect(()=>
//   {
//      isFormValid =
//   otpValue.trim().length === 5 &&
//   Object.values(policies).every(Boolean) &&
//   confirmPassword === newPassword;

//   },[confirmPassword,newPassword])






  const handleNewPasswordChange = (e) => {
    const password = e.target.value;
    setNewPassword(password);

    if (confirmPassword !== password) {
    console.log("Passwords do NOT match");
    setConfirmError("The new password and confirm password do not match.");
  } else {
    console.log("Passwords match");
    setConfirmError("");
  }

    if (!validatePassword(password)) {
      setPasswordError("Your password must meet the following criteria:");
    } else {
      setPasswordError("");
    }
  };

 const handleConfirmPasswordChange = (e) => {
  const password = e.target.value;
  console.log("Confirm Password Entered:", password);

  setConfirmPassword(password);

  console.log("New Password:", newPassword);

  if (password !== newPassword) {
    console.log("Passwords do NOT match");
    setConfirmError("The new password and confirm password do not match.");
  } else {
    console.log("Passwords match");
    setConfirmError("");
  }
};


  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    showSpinner(
      "Updating",
      "Your password update is in progress. Please wait..."
    );

    if (!validatePassword(newPassword)) {
      setPasswordError("Your password must meet the following criteria:");
      setIsLoading(false);
      return;
    }

    if (newPassword !== confirmPassword) {
      setConfirmError("The new password and confirm password do not match.");
      setIsLoading(false);
      return;
    }
    try {
      const response = await verifyResetOtp(otpValue, email);
      if (response.otpVerified === true) {
        const result = await resetPassword(email, newPassword);
        console.log("this is reset password response:", result);
        if (result.status === 200 && result.data.pwdUpdated === true) {
          setIsLoading(false);
          Swal.close();
          showMessageCustom(
            "Your password has been updated successfully.",
            "Please proceed to login with your new password.",
            () => {

              window.location.href = "/web/hayak/login-page";
            }
          );
          return;
        } else if (
          result.status === 200 &&
          result.data.pwdUpdated === false &&
          result.data.message === "unable to update password"
        ) {
          showMessageCustom(
            "Please enter a new password instead of old one.",
            "",
            () => {

              navigate("/");
            }
          );
        } else {
          showMessageCustom(result?.data.message, "", () => {

            navigate("/");
          });
        }
      } else {
        showMessageCustom(
          "The OTP entered is invalid.",
          "Please enter the otp received on registered email id.",
          "",
          () => {

            navigate("/");
          }
        );
      }
    } catch (e) {
      console.error("Error updating password:", e);
      showMessageCustom(
        "The OTP entered is invalid.",
        "Please enter the otp received on registered email id.",
        "",
        () => {

          navigate("/");
        }
      );
    }

    setIsLoading(false);
  };

 const handleBackToLogin = () => {
  window.location.href = `${window.location.origin}/`;
};

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12 col-md-8 px-4">
          <div className="left-title-bg">
            <p className="left-title">Set new password</p>
          </div>
          <div className="content tracking">
            {/* <ReviewHeader /> */}
            <p className="mb-0 font-20 font-md-30 font-weight-800">
              Set new password
            </p>
            <p>
              Set a new password to protect your account. Follow the security
              guidelines to ensure your password is strong and safe.
            </p>
            
            <div class="align-center justify-content-center">
              <div class="text-center w-100 pr-60 ">
                <img
                  src={getImageUrl("login-image.svg")}
                  alt="img"
                  class="w-100 mb-40 d-md-none"
                />

                <h1 class="font-20 font-weight-600 my-25">
                </h1>
                <span>
                  <div  class="d-flex my-5">
                    <img style={{transform: "rotate(180deg)"}}
                      src={getImageUrl("icon-arrow-backspace.svg")}
                      alt="img"
                      class="mr-5 left-arrow"
                    />
                    <a
                      onClick={() => {
                        dispatch(userActions.logout());
                        navigator("/forgot-password");
                      }}
                      class="text-light-default font-weight-600 cursor-pointer"
                    >
                      Back to change your email address
                    </a>
                  </div>
                </span>
                <form id="forgot">
                  <div className="row form-default">
                    <div class="col-12 align-items-start col-md-8 login-field align-center mx-2 text-left mb-3">
                      <div class="mr-3">
                        <img src={getImageUrl("icon-lock.svg")} alt="img" />
                      </div>
                      <div className="form-group">
                        <label>Enter verification code</label>

                        <input
                          aria-valuenow={"Enter verification code"}
                          style={{ width: "335px" }}
                          id="verificationcode"
                          maxLength={5}
                          type="String"
                          value={otpValue}
                          onKeyDown={(e) => {
                            const allowedKeys = [
                              "Backspace",
                              "ArrowLeft",
                              "ArrowRight",
                              "Delete",
                              "Tab",
                              "+",
                            ];
                            const isDigit = /^\d$/.test(e.key);
                            const isAllowedSymbol =
                              e.key === "+" && e.target.selectionStart === 0; // allow only at the beginning

                            if (
                              !isDigit &&
                              !allowedKeys.includes(e.key) &&
                              !isAllowedSymbol
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => setOtpValue(e.target.value)}
                          name="verification-code"
                          class="form-control"
                          placeholder="Enter verification code"
                        />
                      </div>
                    </div>
                    <div class="col-12 align-items-start col-md-8 login-field align-center mx-2 text-left mb-3">
                      <div class="mr-3">
                        <img src={getImageUrl("icon-lock.svg")} alt="img" />
                      </div>

                      <div class="form-group w-50">
                        <label>New password</label>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <input
                            aria-valuenow={"New password"}
                            id="newPassword"
                            type={shownewpassword ? "text" : "password"}
                            value={newPassword}
                            style={{ width: "calc(100% - 40px)" }} // adjust to leave space for the icon
                            onChange={handleNewPasswordChange}
                            name="new-password"
                            class="form-control"
                            placeholder="Enter new password"
                          />
                          {newPassword && (
                            <span
                              onClick={() =>
                                setShownewpassword(!shownewpassword)
                              }
                              className="ms-2"
                              style={{ cursor: "pointer" }}
                            >
                              {
                                <img
                                  src={
                                    !shownewpassword
                                      ? getImageUrl("eye-close.svg")
                                      : getImageUrl("eye-open.svg")
                                  }
                                  alt="img"
                                />
                              }
                            </span>
                          )}
                        </div>
                        {passwordError && (
                          <p style={{ color: "red" }}>{passwordError}</p>
                        )}
                        <ul style={{ marginTop: "10px", paddingLeft: "20px" }}>
                          <li
                            style={{ color: policies.length ? "green" : "red" }}
                          >
                            At least 8 characters
                          </li>
                          <li
                            style={{
                              color: policies.uppercase ? "green" : "red",
                            }}
                          >
                            At least one uppercase letter
                          </li>
                          <li
                            style={{
                              color: policies.lowercase ? "green" : "red",
                            }}
                          >
                            At least one lowercase letter
                          </li>
                          <li
                            style={{ color: policies.digit ? "green" : "red" }}
                          >
                            At least one digit
                          </li>
                          <li
                            style={{
                              color: policies.special ? "green" : "red",
                            }}
                          >
                            At least one special character
                          </li>
                        </ul>
                      </div>
                    </div>{" "}
                    <div class="col-12 align-items-start col-md-8 login-field align-center mx-2 text-left mb-3">
                      <div class="mr-3">
                        <img src={getImageUrl("icon-lock.svg")} alt="img" />
                      </div>
                      <div class="form-group w-50">
                        <label>Confirm password</label>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <input
                            aria-valuenow={"New password"}
                            id="confirmPassword"
                            type={showconfirmpassword ? "text" : "password"}
                            value={confirmPassword}
                            onChange={handleConfirmPasswordChange}
                            style={{ width: "calc(100% - 40px)" }} // adjust to leave space for the icon
                            name="new-password"
                            class="form-control"
                            placeholder="Confirm your password"
                          />
                          <span
                            onClick={() =>
                              setShowconfirmpassword(!showconfirmpassword)
                            }
                            className="ms-2"
                            style={{ cursor: "pointer" }}
                          >
                            {
                              <img
                                src={
                                  !showconfirmpassword
                                    ? getImageUrl("eye-close.svg")
                                    : getImageUrl("eye-open.svg")
                                }
                                alt="img"
                              />
                            }
                          </span>
                        </div>
                        {confirmError && (
                          <p style={{ color: "red" }}>{confirmError}</p>
                        )}
                      </div>
                    </div>
                    <div
                      className="my-40 col-md-8 d-flex "
                      style={{ justifyContent: "center" }}
                    >
                      <button
                        type="button"
                        className="btn btn-default next-step px-30"
                          disabled={isLoading || !(otpValue.trim().length === 5 &&
  Object.values(policies).every(Boolean) &&
  newPassword===confirmPassword)}


                        onClick={(e) => {
                         
                          handleSubmit(e);
                        }}
                      >
                        {isLoading ? "Reseting..." : "Reset password"}
                      </button>
                    </div>
                    <button
  type='button'
  class='back-login-btn text-yellow font-16 font-weight-600 d-flex align-center mx-auto'
 onClick={handleBackToLogin}
>
  <span className="long-arrow text-yellow"></span>
  Back to Login
</button>
                  </div>{" "}
                  
                </form>
              </div>
            </div>
            <div className="row form-default">
              <div className="col-12 col-md-4">
                <div className="form-group"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
